import * as React from "react";
import Skeleton from "react-loading-skeleton";

interface SkeletonWrapperProps {
    loading: boolean;
    children: React.ReactNode;
}

const SkeletonWrapper = ({ loading, children }: SkeletonWrapperProps) => {
    if (loading) {
        return (
            <div className="p-2 min-w-[100px]">
                <Skeleton count={1} />
            </div>
        );
    } else {
        return <>{children}</>;
    }
};

export default SkeletonWrapper;
